module.exports = __webpack_public_path__ + "img/feature_01.962a1ded.svg";